import LoginUserDomain from "domain/loginUser";

export const types = {
  CHANGE_AVATAR: 'ui/appBar/CHANGE_AVATAR' as const,
  TOGGLE_COLLAPSED_SIDEBAR: 'ui/appBar/TOGGLE_COLLAPSED_SIDEBAR' as const,
  SET_LOGIN_USER: 'ui/appBar/SET_LOGIN_USER' as const,
};

export const changeAvatar = (payload: string) => ({
  type: types.CHANGE_AVATAR,
  payload,
});

export const toggle_collapsed_sidebar = () => ({
  type: types.TOGGLE_COLLAPSED_SIDEBAR,
});

export const set_login_user = (payload: LoginUserDomain | null) => ({
  type: types.SET_LOGIN_USER,
  payload
});

type Actions = (
  | ReturnType<typeof changeAvatar>
  | ReturnType<typeof toggle_collapsed_sidebar>
  | ReturnType<typeof set_login_user>
);

export default Actions;
